import { Settings } from "@/interface/entityInterface";
import axiosInstance from "@/utils/axiosInstance";

export const getSettings = async (settingsId: number) => {
  const { data } = await axiosInstance.get<Settings>(`/settings/${settingsId}`);
  return data
};
